"use client";
import { PrismicNextLink } from "@prismicio/next";
import React from "react";

export default function Cta({
  page,
  padding,
  width,
  hover,
  variant = "default", 
}) {
  let variantClasses = "";

  switch (variant) {
    case "outline":
      variantClasses = `bg-transparent text-white border-white hover:bg-yellow hover:border-transparent hover:text-dark-green`;
      break;
    case "outline-green":
      variantClasses = `bg-transparent text-dark-green border-dark-green hover:border-transparent hover:bg-yellow`;
      break;
    default:
      variantClasses = `bg-yellow text-dark-green border-transparent hover:bg-transparent hover:border-${hover} hover:text-${hover}`;
  }

  return (
    <PrismicNextLink
      field={page}
      className={`cta-text rounded-lg cursor-pointer py-2.5 border no-underline text-center transition ${padding} ${width} ${variantClasses}`}
    />
  );
}
